import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider } from "antd";
import { ColumnProps } from "antd/lib/table";
import Table from "../../general/table-components/table";
import ReportContext from "../../../context/report/context";
import { ILowStockReportItem } from "../../../models/report/response";
import Tag from "../../general/antd/tag";

const LowStockReportTable = () => {
  const { t } = useTranslation();
  const { lowStockData, actions } = useContext(ReportContext);

  if (!lowStockData) return null;

  const columns: ColumnProps<ILowStockReportItem>[] = [
    {
      title: t("product_name"),
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
    },
    {
      title: t("trademark_name"),
      dataIndex: "trademark_name",
      key: "trademark_name",
      align: "center",
    },
    {
      title: t("unit_name"),
      dataIndex: "unit_name",
      key: "unit_name",
      align: "center",
    },
    {
      title: t("sold_from_orders"),
      dataIndex: "sold_from_orders",
      key: "sold_from_orders",
      align: "center",
    },
    {
      title: t("sold_from_stock"),
      dataIndex: "sold_from_stock",
      key: "sold_from_stock",
      align: "center",
    },
    {
      title: t("is_matched"),
      dataIndex: "is_matched",
      key: "is_matched",
      align: "center",
      render: (value: number) => {
        return value ? (
          <Tag title="yes" color="green" />
        ) : (
          <Tag title="no" color="red" />
        );
      },
    },
    {
      title: t("entered_quantity_in_unit"),
      dataIndex: "entered_quantity_in_unit",
      key: "entered_quantity_in_unit",
      align: "center",
    },
    {
      title: t("withdrawn_quantity_in_unit"),
      dataIndex: "withdrawn_quantity_in_unit",
      key: "withdrawn_quantity_in_unit",
      align: "center",
    },
    {
      title: t("current_stock"),
      dataIndex: "quantity_in_unit",
      key: "quantity_in_unit",
      align: "center",
    },
  ];

  return (
    <>
      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h3 style={{ margin: 0 }}>{t("low_stock_report_results")}</h3>
        <Button onClick={() => actions.clearLowStockData()}>
          {t("close")}
        </Button>
      </div>
      <Table<any>
        rowKey={(_, index) => index as number}
        showPagination={false}
        columns={columns}
        dataSource={lowStockData}
        loading={false}
        size="small"
      />
    </>
  );
};

export default LowStockReportTable;
